import { ReactNode } from 'react';
import { getCmsTemplate } from '@helpers/cmsTemplateHelper';
import { PageWithSlots } from '@api/interfaces/pageApi';

interface Props {
  children?: ReactNode;
  cmsPage: PageWithSlots;
}

const CmsTemplate = ({ cmsPage, children }: Props) => {
  return getCmsTemplate(cmsPage, children);
};

export default CmsTemplate;
